// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Rx6i","col":"CardReaderDesc_col__1cL4c","label":"CardReaderDesc_label__Q5EUL"};